import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { shouldSuppressInvalidTypeErrors, isEmptyRequiredValue } from '@app/schema-form/utils/utils';
import { ISchema } from 'ngx-schema-form/lib/model/ISchema';

/** Pipe to convert schema form validation errors into translated messages. */
@Pipe({
	name: 'sfValidationError',
	standalone: false,
})
export class SfValidationErrorPipe implements PipeTransform {
	/** Transform schema form validation errors into translated messages. */
	transform(errors: ValidationErrors | null, schema?: ISchema, value?: unknown): string {
		const isEmptyRequired = schema.isRequired ? isEmptyRequiredValue(schema.type, value) : false;
		const errorCode = isEmptyRequired
			? 'OBJECT_MISSING_REQUIRED_PROPERTY'
			: (Object.values(errors ?? {})?.[0]?.code as string);
		if (!errorCode || (shouldSuppressInvalidTypeErrors(errors) && !isEmptyRequired)) return;
		if (schema?.validation?.[errorCode]) return schema.validation[errorCode] as string;
		switch (errorCode) {
			case 'OBJECT_MISSING_REQUIRED_PROPERTY':
			case 'ONE_OF_MISSING':
				return $localize`:@@SchemaFormRequired:Required`;
			case 'MIN_LENGTH':
				return $localize`:@@SchemaFormMinLength:Minimum length is` + ` ${schema?.minLength}`;
			case 'PATTERN':
				return $localize`:@@SchemaFormPattern:Pattern must be` + ` ${schema?.pattern as string}`;
			case 'INVALID_TYPE':
				return $localize`:@@SchemaFormInvalidType:Invalid type`;
			default:
				return $localize`:@@SchemaFormNotImplemented:Not implemented`;
		}
	}
}
